/* eslint-disable max-classes-per-file */
/* eslint-disable no-useless-constructor */
import { CONCEPTS } from '@rover/rsdk/src/concepts';
import type { ConsentPurpose } from '@rover/rsdk/src/modules/Analytics';
import { AnalyticsEvent } from '@rover/types/src/Analytics';

abstract class EmailCaptureEvent extends AnalyticsEvent {
  consentPurpose: ConsentPurpose = 'marketing';

  concept = CONCEPTS.marketing.growth;

  constructor(eventProperties: { pageName: string }) {
    super(eventProperties);
  }
}

/**
 * &nbsp;
 *
 * # Description
 *
 * This event should trigger every time a user clicks into email input.
 * For more context, check the IP: https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/4008182812/IP+Update+Footer+s+Email+Capture
 *
 * &nbsp;
 */
export class EmailCaptureInteract extends EmailCaptureEvent {
  eventName = 'rover-email-interact';
}

/**
 * &nbsp;
 *
 * # Description
 *
 * This event should trigger every time a user submits a correctly formatted email.
 * For more context, check the IP: https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/4008182812/IP+Update+Footer+s+Email+Capture
 *
 * &nbsp;
 */
export class EmailCaptureSubmit extends EmailCaptureEvent {
  eventName = 'rover-email-submit';
}

/**
 * &nbsp;
 *
 * # Description
 *
 * This event should trigger every time a user attempts to submit email that fails validation.
 * For more context, check the IP: https://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/4008182812/IP+Update+Footer+s+Email+Capture
 *
 * &nbsp;
 */
export class EmailCaptureError extends EmailCaptureEvent {
  eventName = 'rover-email-error';
}

/**
 * &nbsp;
 *
 * # Description
 *
 * This event should trigger every time a user attempts to submit email without checking consent checkbox (if presented).
 * For more context, check the IP: hhttps://roverdotcom.atlassian.net/wiki/spaces/TECH/pages/4008182812/IP+Update+Footer+s+Email+Capture
 *
 * &nbsp;
 */
export class EmailCaptureSubmitNoConsent extends EmailCaptureEvent {
  eventName = 'rover-submit-no-consent';
}
